/*
Copyright 2026 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import type { MatrixRtcOwnMembershipPayload } from "./types";

/**
 * Проверяет смысловое равенство собственного MatrixRTC membership.
 * Времена создания и продления намеренно не учитываются, чтобы renewal не засорял журнал.
 */
export function areOwnMembershipsSemanticallyEqual(
  previous: MatrixRtcOwnMembershipPayload | null,
  current: MatrixRtcOwnMembershipPayload | null,
): boolean {
  if (previous === null || current === null) return previous === current;
  return (
    previous.callId === current.callId &&
    previous.callIntent === current.callIntent &&
    previous.expired === current.expired &&
    previous.focusSelection === current.focusSelection &&
    [...previous.preferredFocusTypes].sort().join("\u0000") ===
      [...current.preferredFocusTypes].sort().join("\u0000")
  );
}
